import React from 'react';
import PropTypes from 'prop-types';
import { decorateUrlWithItm } from 'utils/itm';

const Dropdown = ({ category }) => {
    const ListItem = (item, index, header = false) => {
        return (
            <li
                key={index}
                className="border-0 pt-1 pb-2 category-section--list-item">
                <a
                    href={decorateUrlWithItm(item.href, {
                        source: 'startpage',
                        medium: 'mega-menu'
                    })}
                    alt={item.text}
                    title={`Visa ${header ? header : ''} ${item.text}`}
                    className={
                        item.moreLink
                            ? 'more-link font-weight-bold'
                            : 'text-dark'
                    }>
                    {item.text} {item.moreLink ? '>' : ''}
                </a>
            </li>
        );
    };

    const CategorySection = (section, index) => {
        const isFirstSection = index === 0;
        return (
            <div
                key={index}
                className={
                    isFirstSection
                        ? 'col-8 py-4'
                        : 'col-2 p-4 category-section--secondary'
                }>
                <h5
                    className="w-100 font-weight-bold pb-2"
                    title={section.header}>
                    {section.header}
                </h5>
                <ul
                    className={`list-unstyled ${
                        isFirstSection ? 'category-section-first' : ''
                    }`}>
                    {section.categorySectionGroups.map(({ sectionLinks }) =>
                        sectionLinks.map((item, index) =>
                            ListItem(
                                item,
                                index,
                                !isFirstSection && section.header
                            )
                        )
                    )}
                </ul>
            </div>
        );
    };

    return (
        <div
            className={`dropdown-menu mt-0 d-flex col-12 p-4 show rounded-0 border-top-0`}
            role="tabpanel">
            {category.categorySections.map(CategorySection)}
        </div>
    );
};

Dropdown.propTypes = {
    category: PropTypes.array.isRequired
};

export default Dropdown;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/mega-menu-categories/dropdown.jsx